import { useModelService } from "@shared/services/api/hooks/useModelService";
import { useMemo } from "react";
import PublicCharityRepository from "../repositories/PublicCharityRepository";

/**
 * Service to retrieve charity information using the PublicCharityRepository.
 */
const usePublicCharityService = () => {
  const repository = useMemo(() => new PublicCharityRepository(), []);
  const {
    useList,
    useCreate,
    useRetrieve,
    useUpdate,
    useDelete,
    usePaginated,
    invalidateSubcategoryQueries,
  } = useModelService(repository);

  return {
    useList,
    useCreate,
    useRetrieve,
    useUpdate,
    useDelete,
    usePaginated,
    invalidateSubcategoryQueries,
  };
};

export default usePublicCharityService;
